import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ChevronDown = forwardRef<SVGSVGElement, SvgIconProps>(
  function ChevronDown(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M18.65 8.26a1.14 1.14 0 00-1.52.06L12 13.52l-5.13-5.2c-.4-.4-1.08-.43-1.52-.06a.95.95 0 00-.07 1.42l5.93 6 .03.02.03.04c.06.05.14.08.2.11.05.03.08.06.13.07.13.05.26.08.4.08s.27-.03.4-.08c.05-.01.08-.04.12-.07.07-.03.15-.06.2-.11l.04-.04.03-.02 5.93-6a.95.95 0 00-.07-1.42" />
      </SvgIcon>
    )
  },
)

export default ChevronDown
